import { forwardRef, MouseEvent, Ref, useEffect, useImperativeHandle, useRef } from 'react';
import { StyledSlotDate, StyledSlotDateName, StyledSlotDateText } from './SlotDate.styles';

interface Props {
  date: DayDate;
  onClick: (date: DayDate) => void;
  isSelected: boolean;
}

const SlotDate = forwardRef(({ date, onClick, isSelected }: Props, ref: Ref<HTMLButtonElement>) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const onClickHandler = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (onClick) {
      onClick(date);
    }
  };

  useImperativeHandle(ref, () => buttonRef.current!, [buttonRef]);

  useEffect(() => {
    if (isSelected) {
      // Only focus if not already focused
      if (document.activeElement !== buttonRef.current) {
        buttonRef.current?.focus();
      }
    }
  }, [isSelected]);

  return (
    // @ts-ignore
    <StyledSlotDate type="button" onClick={onClickHandler} ref={buttonRef} selected={isSelected}>
      <StyledSlotDateName selected={isSelected}>{date.dayName}</StyledSlotDateName>
      <StyledSlotDateText selected={isSelected}>{date.dateText}</StyledSlotDateText>
    </StyledSlotDate>
  );
});
SlotDate.displayName = 'SlotDate';

export default SlotDate;
